module.exports = __webpack_public_path__ + "img/screenshot-3.63442ce1.png";